export const gitCommit = 'cf15ca07'
